import React from "react";

import { useState, useEffect } from "react";

// @mui material components
import Api from "../../Classes/API/UsersApi";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { useParams } from "react-router-dom";
import GetEmployeeTypesById from "../../Classes/Models/Requests/Administration/Employees/GetEmployeeTypesById";
import CardHeader from "@mui/material/CardHeader";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useContext } from "react";
import MDInput from "components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CreateTherapistEmployeeTypeReq from "Classes/Models/Requests/Administration/Types/CreateTherapistEmployeeTypeReq";
import Swal from "sweetalert2";
import { LanguageContext } from "App";

const EdittherapistTypeType = () => {
  const { id } = useParams();
  const [TherapistTypeName, SetTherapistTypeName] = useState("");
  const [TherapistTypeHourlyRate, SetTherapistTypeHourlyRate] = useState("");
  const [ErrorText, SetErrorText] = useState(false);
  const [IsLoaded, SetIsLoaded] = useState(false);
  const { translations } = useContext(LanguageContext);
  let therapistModel = new GetEmployeeTypesById();

  useEffect(async () => {
    therapistModel.searchInt = parseInt(id);
    await Api.GetTherapistTypeById(therapistModel).then((response) => {
      SetTherapistTypeName(response.data.typeName);
      SetTherapistTypeHourlyRate(response.data.standardHourlyRate);
    });
  }, ["default"]);

  const GetData = async () => {
    let employeeModel = new GetEmployeeTypesById();
    employeeModel.searchInt = parseInt(id);
    var res = await Api.GetTherapistTypeById(employeeModel);
    if (res.status == "Success") {
      SetTherapistTypeName(res.data.typeName);
      SetTherapistTypeHourlyRate(res.data.standardHourlyRate);
      SetIsLoaded(true);
    }
  };

  useEffect(async () => {
    if (!IsLoaded) {
      await GetData();
    }
  }, [IsLoaded]);

  if (!IsLoaded) {
    return <div>LOADING...</div>;
  }

  let CreateTherapistEmployeeTypeReqModel = new CreateTherapistEmployeeTypeReq();
  const submitForm = async () => {
    if (!TherapistTypeName || !TherapistTypeHourlyRate) {
      SetErrorText(true);
      return;
    }

    CreateTherapistEmployeeTypeReqModel.Id = parseInt(id);
    CreateTherapistEmployeeTypeReqModel.TypeName = TherapistTypeName;
    CreateTherapistEmployeeTypeReqModel.StandardHourlyRate = TherapistTypeHourlyRate;
    //debugger
    await Api.EditTherapistType(CreateTherapistEmployeeTypeReqModel).then((response) => {
      if (response.status === "Success") {
        Swal.fire("Therapist Updated", "", "success");
      } else {
        Swal.fire("Error", "", "error");
      }
    });
  };

  return (
    <div>
      <DashboardLayout>
        {/* Page Title */}
        {/* <CardHeader
          className="mb-2"
          title={translations.TherapistTypetableEditEmployeeType}
        ></CardHeader> */}

        {/* Search form */}
        <div className="card mt-3">
          <div className="card-body">
            <CardHeader className="mb-2" title={translations.EmployeeTypeTitle}></CardHeader>
            <div className="container-fluid">
              <div className="row">
                {/* Therapist type name */}
                <div className="col-md-4">
                  {/* <MDInput
                    className="full-width"
                    label={translations.EmployeeTypeTherapisttypename}
                    defaultValue={TherapistTypeName}
                    onChange={(e) => SetTherapistTypeName(e.target.value)}
                  /> */}
                </div>

                {/* standard Hourly Rate */}
                <div className="col-md-4">
                  <TextField
                    className="full-width"
                    label={translations.EmployeeTypeTherapistTypeHourlyRate}
                    type="number"
                    defaultValue={TherapistTypeHourlyRate}
                    onChange={(e) => SetTherapistTypeHourlyRate(e.target.value)}
                  />
                </div>
              </div>

              <div className="text-right mt-3 ">
                <Button className="white" variant="contained" size="medium" onClick={submitForm}>
                  {translations.EmployeeTypetableSave}
                </Button>
              </div>

              {!TherapistTypeName && ErrorText == true && (
                <small
                  className="alert alert-danger font-sm mt-4 mx-0 text-right d-block"
                  role="alert"
                >
                  {" "}
                  برجاء إدخال أسم المعالج{" "}
                </small>
              )}

              {!TherapistTypeHourlyRate && ErrorText == true && (
                <small
                  className="alert alert-danger font-sm mt-4 mx-0 text-right d-block"
                  role="alert"
                >
                  {" "}
                  برجاء إدخال سعر ساعة المعالج{" "}
                </small>
              )}
            </div>
          </div>
        </div>
      </DashboardLayout>
    </div>
  );
};

export default EdittherapistTypeType;
